import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleTheme } from '../store/slices/themeSlice';

const ThemeToggle = () => {
    const dispatch = useDispatch();
    const mode = useSelector((state) => state.theme.mode);
    const isLight = mode === 'light';

    return (
        <button
            type="button"
            onClick={() => dispatch(toggleTheme())}
            className='flex w-full items-center justify-between px-5 py-4 border-b border-custom-charcoal text-left'
        >
            <span>Light Mode</span>
            <span className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${isLight ? 'bg-custom-light-blue' : 'bg-custom-dark-blue'}`}>
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isLight ? 'translate-x-6' : 'translate-x-1'}`} />
            </span>
        </button>
    );
};

export default ThemeToggle;
